import { SummarySearch } from "@/types/OrderItem";
import {
  SalesReturnSearch,
  SalesReturnSearchResult,
  SalesReturnSummaryResult,
} from "@/types/SalesReturn";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const SalesReturnApi = createApi({
  reducerPath: "SalesReturnApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["salesReturn"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getSalesReturn: builder.query({
      query: () => `/salesreturn`,
      providesTags: ["salesReturn"],
    }),
    uploadSalesReturnFile: builder.mutation({
      query: ({ formData }) => ({
        url: `/document/salesreturn/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["salesReturn"],
    }),
    searchReturn: builder.query<SalesReturnSearchResult, SalesReturnSearch>({
      query: (input) => {
        return {
          url: `/salesreturn/search`,
          method: "POST",
          body: { ...input, export: false },
        };
      },
      providesTags: ["salesReturn"],
    }),
    exportSalesReturn: builder.mutation<Blob, SalesReturnSearch>({
      query: (input) => ({
        url: `/salesreturn/search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryOrdesSalesReturn: builder.query<
      SalesReturnSummaryResult,
      SalesReturnSearch
    >({
      query: (input) => ({
        url: `/salesreturn/summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["salesReturn"],
    }),
    deleteSalesReturns: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/salesreturn/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["salesReturn"],
    }),
  }),
});

export const {
  useUploadSalesReturnFileMutation,
  useGetSalesReturnQuery,
  useSearchReturnQuery,
  useLazySearchReturnQuery,
  useExportSalesReturnMutation,
  useSummaryOrdesSalesReturnQuery,
  useDeleteSalesReturnsMutation,
} = SalesReturnApi;
